import { useQuery, gql } from "@apollo/client";

const GET_USER_DATA = gql`
  query {
    me
  }
`;

const useUserData = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_DATA, {
    onError: (e) => console.log(JSON.stringify(e, null, 2)),
  });
  if (error) {
    console.log(error);
  }
  if (typeof data === "string") {
    const parseData = JSON.parse(data.me);
    // console.log("parseData",parseData);
    return { data: parseData };
  }
  // console.log("data",data);
  return { data, refetch };
};

export default useUserData;
